module.exports = __webpack_public_path__ + "static/media/messageIconPDF.6146ca59.png";